import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TextInputField,
} from "../../../../../common-components";
import SearchBar from "../../../../../common-components/search-bar/SearchBar";
import { InviteLinkedUsers, LinkedUserCard } from "./components";

const LinkedUserPop = ({
  display,
  onCloseClick,
  setLinkedUserPopUp,
  setSubSelection,
  auth,
  setLoading,
  setToastPop,
  setMessage,
  setPopUpTitle,
  loading,
}) => {
  const [displayView, setDisplayView] = useState("users");
  const [inviteEmail, setInviteEmail] = useState("");
  const [invitePin, setInvitePin] = useState("");

  const [linkedInvites, setLinkedInvites] = useState([]);
  const [linkedUsers, setLinkedUsers] = useState([]);

  const [selectedRole, setSelectedRole] = useState("");
  const SendInvite = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/createInviteAndSend",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            email: inviteEmail,
            roles: [selectedRole],
            linkedId: auth.customerUserData.userId,
            linkedBrand: "DRIVERS FRIEND CORE",
            createdBy:
              auth.customerUserData.firstName +
              " " +
              auth.customerUserData.lastName,
            pin: invitePin,
            type: "mobileUser",
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.message) {
        setLoading(false);
        setToastPop(true);
        setMessage("You have succesfully sent the invite");
        setPopUpTitle("SUCCESS");
        setDisplayView("users");
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      } else {
        setLoading(false);
        setToastPop(true);
        setMessage("An error has occured");
        setPopUpTitle("FAILURE");
        // setInvitesArray(respnseData.invites);
      }
    } catch (err) {
      setLoading(false);
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  const GetLinkedUsers = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getlinkedUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth ? auth.customerUserData.userId : null,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.linkedUsers) {
        setLinkedUsers(respnseData.linkedUsers);
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      }
      // else {
      //     setLoading(false);
      //     setToastPop(true);
      //     setMessage("An error has occured");
      //     setPopUpTitle("FAILURE");
      //     // setInvitesArray(respnseData.invites);
      //   }
    } catch (err) {
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  const GetPendingLinkedUsers = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userInvites/getlinkedPendingUsers",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            userId: auth ? auth.customerUserData.userId : null,
          }),
        }
      );

      const respnseData = await response.json();

      if (respnseData.linkedUsers) {
        setLinkedInvites(respnseData.linkedUsers);
        // setInvitesArray(respnseData.invites);
        // setToastPop(true);
      }
      // else {
      //     setLoading(false);
      //     setToastPop(true);
      //     setMessage("An error has occured");
      //     setPopUpTitle("FAILURE");
      //     // setInvitesArray(respnseData.invites);
      //   }
    } catch (err) {
      setToastPop(true);
      setMessage("An error has occured");
      setPopUpTitle("FAILURE");

      console.log("error", err);
    }
  };

  useEffect(() => {
    GetPendingLinkedUsers();
    GetLinkedUsers();
  }, [loading]);
  return (
    <div
      style={{
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        position: "absolute",
        bottom: 0,
        transition: "all 0.3s",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 60,
          width: "100%",
          justifyContent:
            displayView === "addUser" ? "flex-start" : "space-evenly",
          alignItems: "center",
          display: "flex",
        }}
      >
        {displayView === "addUser" ? <div style={{ minWidth: 19 }} /> : null}
        <BaseButtons
          label={"X"}
          onClick={
            displayView === "addUser"
              ? () => setDisplayView("invites")
              : () => {
                  setSubSelection("dashboard");
                  setLinkedUserPopUp(false);
                }
          }
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          width={40}
        />
        {displayView === "addUser" ? null : (
          <BaseButtons
            label={"LINKED USERS"}
            //   onClick={onCloseClick}
            borderRadius={8}
            backgroundColor={
              displayView === "users" ? colors.greenDark : colors.white
            }
            width={"35%"}
            color={
              displayView === "users" ? colors.white : colors.secondaryDarkBlue
            }
            onClick={() => setDisplayView("users")}
          />
        )}
        {displayView === "addUser" ? null : (
          <BaseButtons
            label={"INVITES"}
            //   onClick={onCloseClick}
            borderRadius={8}
            backgroundColor={
              displayView === "invites" ? colors.greenDark : colors.white
            }
            width={"35%"}
            color={
              displayView === "invites"
                ? colors.white
                : colors.secondaryDarkBlue
            }
            onClick={() => setDisplayView("invites")}
          />
        )}
        {displayView === "addUser" ? (
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
              fontSize: 18,
            }}
          >
            INVITE NEW USER
          </div>
        ) : null}
        {displayView === "addUser" ? (
          <BaseButtons
            label={"SEND INVITE"}
            width={100}
            backgroundColor={colors.greenLight}
            borderRadius={8}
            onClick={() => SendInvite()}
          />
        ) : null}
        {displayView === "addUser" ? <div style={{ minWidth: 10 }} /> : null}
      </div>
      <div
        style={{
          flex: 1,

          width: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {displayView === "users" ? (
          <div
            style={{
              marginTop: 110,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <SearchBar width={"100%"} size={"80%"} />
            </div>
            <div style={{ minHeight: 10 }} />
            {linkedUsers.length >= 1
              ? linkedUsers.map((user, index) => {
                  return (
                    <div key={index} style={{ width: "100%" }}>
                      <LinkedUserCard
                        linkedUserName={user.username}
                        contactInfo={user.contactNumber}
                        access={user.role}
                      />
                    </div>
                  );
                })
              : null}
          </div>
        ) : null}
        {displayView === "invites" ? (
          <div
            style={{
              marginTop: 120,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
              }}
            >
              <div
                style={{
                  flex: 0.7,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <SearchBar
                  width={"100%"}
                  size={"90%"}
                  placeholder={"search invites"}
                />
              </div>
              <div
                style={{
                  flex: 0.3,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BaseButtons
                  label={"INVITE USER"}
                  width={120}
                  backgroundColor={colors.greenLight}
                  borderRadius={8}
                  onClick={() => setDisplayView("addUser")}
                />
                <div style={{ marginRight: 15 }} />
              </div>
            </div>
            <div style={{ minHeight: 10 }} />
            {linkedInvites.length >= 1
              ? linkedInvites.map((user, index) => {
                  return (
                    <div key={index} style={{ width: "100%" }}>
                      <InviteLinkedUsers
                        linkedUserName={user.username}
                        status={user.status}
                        role={user.role}
                      />
                    </div>
                  );
                })
              : null}
          </div>
        ) : null}
        {displayView === "addUser" ? (
          <div
            style={{
              marginTop: 110,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                height: "100%",
                justifyContent: "center",
                alignItems: "center",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
            >
              <div>
                <TextInputField
                  labelTitle={"EMAIL"}
                  mini={true}
                  value={inviteEmail}
                  onChange={(e) => setInviteEmail(e.target.value)}
                />
                <TextInputField
                  labelTitle={"PIN"}
                  mini={true}
                  value={invitePin}
                  onChange={(e) => setInvitePin(e.target.value)}
                />

                <div
                  style={{
                    marginTop: 20,
                    marginBottom: 15,
                    fontSize: 14,
                    fontWeight: "bold",
                  }}
                >
                  SELECT ROLES
                </div>
                <div style={{ width: 250, fontSize: 12, marginBottom: 10 }}>
                  Depending on the role assigend to invites user they will gain
                  access to different actions and modules
                </div>
                <CheckInput
                  label={"DRIVER"}
                  selected={selectedRole === "DRIVER"}
                  onClick={() => setSelectedRole("DRIVER")}
                />
                <div style={{ minHeight: 6 }} />
                <CheckInput
                  label={"VIEW"}
                  selected={selectedRole === "FAMILY"}
                  onClick={() => setSelectedRole("FAMILY")}
                />
                <div style={{ minHeight: 6 }} />
                <CheckInput
                  label={"FAMILY"}
                  selected={selectedRole === "FRIEND"}
                  onClick={() => setSelectedRole("FRIEND")}
                />
                <div style={{ minHeight: 6 }} />
                <CheckInput
                  label={"MANAGE"}
                  selected={selectedRole === "AGENT"}
                  onClick={() => setSelectedRole("AGENT")}
                />
                <div style={{ minHeight: 6 }} />
                <CheckInput
                  label={"AGENT"}
                  selected={selectedRole === "AGENT"}
                  onClick={() => setSelectedRole("AGENT")}
                />
                <div style={{ minHeight: 15 }} />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default LinkedUserPop;
